import React from "react";
import { inject } from "mobx-react";
import { debounce } from "lodash";
import HttpClient from "services/HttpClient";

const USERS_FOR_ASSIGN_RESULT_URL = "/api/v1/workshops/users_for_assign/?name=";
const USERS_FOR_ASSIGN_CHANGE_URL = "/api/v1/workshops/assign_provider/";

@inject("modal")
export default class SearchAtendee extends React.Component {
  constructor(props) {
    super(props);
    this.debounceGetUsersByName = debounce(this.getUsersByName, 500);
  }

  state = {
    inputName: "",
    searchResult: [],
    searchSelectedId: ""
  };

  closeModal = () => {
    this.props.modal.toggleModal();
  };

  handleInput = e => {
    const name = e.target.value;
    this.setState(
      {
        inputName: name
      },
      () => {
        this.debounceGetUsersByName(name);
      }
    );
  };

  getUsersByName = name => {
    new HttpClient().get(USERS_FOR_ASSIGN_RESULT_URL + name).then(response => {
      this.setState({
        searchResult: response.body.data.users
      });
    });
  };

  // assignNewUser = () => {
  //   const workshopIdUrl = this.props.modal.parentId;
  //   const userIdData = { provider_id: this.state.searchSelectedId };
  //   console.log("Selected user id =", userIdData);
  //   new HttpClient()
  //     .put(USERS_FOR_ASSIGN_CHANGE_URL + workshopIdUrl, userIdData)
  //     .then(response => {
  //       // console.log(response);
  //       if (response.status === 200) {
  //         this.props.modal.toggleUpdateComponent();
  //         this.props.modal.toggleModal();
  //       }
  //     });
  // };

  selectUser = userId => {
    this.setState({
      searchSelectedId: userId
    });
    // console.log("Id of selected user is =", userId);
  };

  resultContent = () => {
    let searchOutput = this.state.searchResult;
    if (searchOutput.length > 0) {
      return (
        <ul className="results-list">
          {this.state.searchResult.map(user => (
            <li
              onClick={() => this.selectUser(user.id)}
              key={user.id}
              className={
                user.id === this.state.searchSelectedId ? "selected" : ""
              }
            >
              <span className="user-name">{user.name}</span>
              <span className="user-email">&#128387; {user.email}</span>
            </li>
          ))}
        </ul>
      );
    } else {
      return (
        <ul className="results-list">
          <li className="no-result-attendee">No results so far</li>
        </ul>
      );
    }
  };

  componentDidMount() {
    let modalStore = this.props.modal.assignedTo;
    if (Object.keys(modalStore).length != 0) {
      const name = this.props.modal.assignedTo.full_name;
      this.getUsersByName(name);
    } else {
      this.getUsersByName("");
    }
  }

  handleSubmit = () => {
    this.props.modal.submitFunction(this.state.searchSelectedId);
  };

  render() {
    return (
      <div className="modal-window-wrapper">
        <div className="inner-modal-window search-attendee">
          <div className="inputs-wrapper">
            <div className="search-row">
              <div className="row">
                <div className="col search-wrapper">
                  <span className="ic-search-ico" />
                  <input
                    type="text"
                    className="search-field"
                    placeholder="Find user"
                    value={this.state.inputName}
                    onChange={this.handleInput}
                  />
                </div>
              </div>
            </div>
            <div className="list-row">
              <div className="row">
                <div className="col">{this.resultContent()}</div>
              </div>
            </div>
            <div className="buttons-row">
              <button
                type="submit"
                className="btn-submit"
                onClick={() => this.handleSubmit()}
              >
                Confirm
              </button>
              <button className="btn-cancel" onClick={this.closeModal}>
                cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/SearchAtendee.jsx